import { Component } from '@angular/core';
import { NavTabService } from '../../../../services/nav-tab.service';
import { WebService } from '../../../../services/web.service'; 
import { QuickLinkService } from '../../../../services/quick-links.service'; 
import { lastValueFrom } from 'rxjs';
import { RmsModule } from '../../../../custom-modules/rms-module/rms.module'

@Component({
  selector: 'app-quick-link-search-po',
  imports: [RmsModule],
  templateUrl: './quick-link-search-po.component.html',
  styleUrl: './quick-link-search-po.component.scss'
})
export class QuickLinkSearchPoComponent {
  searchOption: string = 'PO #';
  searchText: string = '';

  constructor(private navTab: NavTabService, private web: WebService, private quickLinkService: QuickLinkService) { }

  async submitPoSearch() {
    const navItem = this.navTab.getNavItemFromTitle("Purchase Orders");
    if (navItem) {
      if (this.searchOption === 'PO #') {
        this.navTab.addTab({ title: navItem.title, icon: navItem.icon, componentKey: navItem.componentKey, data: { PurchaseOrderID: parseInt(this.searchText) } })
      } else {
        const purchaseOrder = await lastValueFrom(this.web.getWebCall("inventory", "coffee/inventory/purchase-order", { params: [{ name: 'InventoryID', value: parseInt(this.searchText) }] }))
        this.navTab.addTab({ title: navItem.title, icon: navItem?.icon, componentKey: navItem?.componentKey, data: { PurchaseOrderID: purchaseOrder[0]?.PurchaseOrderID } })
      }
      this.quickLinkService.triggerClose();
    }
  }
  cancelSearch() {
    this.quickLinkService.triggerClose();
  }
}
